import { IExceptionTelemetry } from '@microsoft/applicationinsights-common';
import { FC, ReactNode, useEffect, useState } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { v4 } from 'uuid';
import { useAppInsights } from '../../helpers/AppInsights';
import strings from './errors.translations';
import { SubmissionErrorContents } from './SubmissionErrorContents';

export const SubmissionError: FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  const [exception, setException] = useState<IExceptionTelemetry>();
  const appInsights = useAppInsights();

  useEffect(() => {
    if (!error) return;
    const exception = {
      id: v4(),
      exception: error
    };
    setException(exception);
    appInsights.trackException(exception);
  }, [error, appInsights]);

  const resetAndGoHome = () => {
    resetErrorBoundary();
    setException(undefined);
  };

  return exception ? (
    <SubmissionErrorContents
      error={error}
      trackingId={exception?.id}
      buttonActionLabel={strings.tryAgain}
      onButtonAction={resetAndGoHome}
    />
  ) : null;
};

export const SubmissionErrorBoundary: FC<{children: ReactNode}> = ({ children }) => {
  return <ErrorBoundary FallbackComponent={SubmissionError}>{children}</ErrorBoundary>;
};
